import React from 'react';
import PropTypes from 'prop-types';
import { CardBody } from 'reactstrap';

const TimeLineIcon = ({ type, color }) => {
  let Icon;

  switch (type) {
    case 'coffee':
      Icon = <span className="lnr lnr-coffee-cup" />;
      break;
    case 'machine':
      Icon = <span className="lnr lnr-coffee-cup" />;//lnr-funnel
      break;
    default:
      break;
  }

  return (
    <div className={`timeline__icon ${color}`}>
      {Icon}
    </div>
  );
};

TimeLineIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
};

TimeLineIcon.defaultProps = {
  type: '',
  color: '',
};

const TimeLineItem = ({
  type, color, img, title, date, createdAt, clientName, children,
}) => (
  <div className="timeline__item">
    {img && type === 'machine'
      ? <div className={`timeline__icon ${color}`}><img src={img} alt="img" /></div>
      : <TimeLineIcon type={type} color={color} />
    }
    <CardBody className="timeline__content">
      <h5 className="timeline__title">{title}</h5>
      <h4 className="subhead timeline__date" title={createdAt}>{date}</h4>
      <h4 className="subhead timeline__date">{clientName}</h4>
      {children}
    </CardBody>
  </div>
);

TimeLineItem.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  img: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  createdAt: PropTypes.string,
  clientName: PropTypes.string,
  children: PropTypes.element.isRequired,
};

TimeLineItem.defaultProps = {
  type: '',
  color: '',
  img: '',
  title: '',
  date: '',
  createdAt: '',
  clientName: '',
};

export default TimeLineItem;
